import { demoUrGroups } from "assets/data/communities";
import { Link } from "react-router-dom";
import { Card, CardFilter, CreatedCommunity } from "ui";
const CreatedCommunities = () => {
    return (
        <Card className="w-full h-full flex flex-col gap-5">
            <div className="flex flex-col justify-start items-start gap-2 dark:text-white">
                <h2 className="text-lg font-medium">
                    Recently Created Communities
                </h2>
                <CardFilter
                    dropDownItems={[
                        "Community Name",
                        "User ID",
                        "Country",
                        "Words",
                        "Members Name"
                    ]}
                />
            </div>
            <div className="flex flex-col justify-start items-center gap-5 py-2 w-full h-full bg-neutral-50 dark:bg-momeento-100 rounded overflow-auto">
                {demoUrGroups.map((g) => (
                    <CreatedCommunity community={g} key={g.id} />
                ))}
            </div>
            <div className="w-full text-center">
                <Link
                    to="/communities"
                    className="w-fit px-5 py-2 text-sm text-center bg-momeento-50 text-white hover:shadow-xl rounded-full"
                >
                    View More...
                </Link>
            </div>
        </Card>
    );
};
export default CreatedCommunities;
